import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { green, grey } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { isUserOnline } from "@markedesk/core-contracts";

const useStyles = makeStyles((theme) => ({
  on: {
    color: green[600],
    fontSize: "20px",
  },
  off: {
    color: grey[600],
    fontSize: "20px",
  },
}));

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();
  if (!user || typeof user.online === "undefined") {
    return (
      <Tooltip title="Desconhecido">
        <ErrorIcon className={classes.off} />
      </Tooltip>
    );
  }
  // #4433: a coluna sozinha mente quando o backend cai sem gravar o offline.
  // A regra de "esta online" e a mesma no back e no front (core-contracts).
  return isUserOnline(user) ? (
    <Tooltip title="Online">
      <CheckCircleIcon className={classes.on} />
    </Tooltip>
  ) : (
    <Tooltip title="Offline">
      <ErrorIcon className={classes.off} />
    </Tooltip>
  );
};

export default UserStatusIcon;
